import React from "react"

import Hero from "../components/Hero"
import Layout from "../components/Layout"

function index() {
  return (
    <Layout>
      <Hero />
    </Layout>
  )
}

export default index
